import { PropsWithChildren, useRef } from 'react'
import cx from 'classnames'
import Styles from './Chip.module.scss'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'

interface ChipProps {
  onPress: () => void
  size?: 'sm' | 'md'
  variant?: 'blue' | 'grey'
  isDisabled?: boolean
}

export const Chip = ({
  children,
  onPress,
  size = 'sm',
  variant = 'blue',
  isDisabled = false,
}: PropsWithChildren<ChipProps>) => {
  const ref = useRef<HTMLDivElement>(null)
  const { buttonProps } = useButtonWithScrollCancel({ onPress, elementType: 'div', isDisabled }, ref)
  return (
    <div
      {...buttonProps}
      className={cx(Styles.chip, Styles[size], Styles[variant], { [Styles.disabled]: isDisabled })}
      ref={ref}
    >
      {children}
    </div>
  )
}
